import React from 'react';

import {IDropdownContext} from './IDropdownContext';

const initialValue = {
	value: '',
	showMenu: false,
	menuCoords: null,
	disabled: false,
	menuDirection: '',
	handleShowMenu: () => {},
	setMenuRef: () => {},
};

export default React.createContext<IDropdownContext>(initialValue);
